export default "/images/vendor/flag-icons/flags/1x1/nc.svg?74229c544bb0394b7a837e77e861ec18";